import React from 'react';
import { InputAdornment, useTheme } from '@mui/material';
import NumericTextField, {
  type NumericTextFieldProps,
} from './NumericTextField';

export type AdornedCurrencyInputProps = Omit<
  NumericTextFieldProps,
  'slotProps' | 'sx'
>;

const AdornedCurrencyInput: React.FC<AdornedCurrencyInputProps> = (props) => {
  const theme = useTheme();
  const { error } = props;

  return (
    <NumericTextField
      {...props}
      sx={{
        '& .MuiOutlinedInput-input::placeholder': {
          color: error
            ? theme.palette.error.main
            : theme.palette.text.secondary,
          opacity: 1,
        },
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment
              position='start'
              sx={{
                '& .MuiTypography-root': {
                  color: error
                    ? theme.palette.error.main
                    : theme.palette.text.secondary,
                },
              }}
            >
              {' '}
              $
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default AdornedCurrencyInput;
